module.exports = __webpack_public_path__ + "static/img/cont3612.e80e475.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont3612.jpg
// module id = lR7p
// module chunks = 0